import Vue from 'vue'

function list (params = {}) {
  const path = '/admin/external-crm-push-logs'
  return Vue.api.get(path, { params })
}

function load (params = {}) {
  const path = `/admin/external-crm-push-logs/${params.id}`
  return Vue.api.get(path, { params })
}

export default {
  list,
  load
}
